import { Flex, Stack } from '@chakra-ui/react';
import Header from '@components/typography/Header';
import Card from './Card';

const Popular = ({ featuredPosts }) => {
  return (
    <Stack w="100%" spacing={2} py={[2, 2, 4]}>
      <Header as="h3">Popular</Header>
      <Flex w="100%" gap={4} py={4} direction={['column', 'column', 'row']}>
        {featuredPosts.map((post) => (
          <Card key={post.id} post={post} />
        ))}
      </Flex>
    </Stack>
  );
};

export default Popular;
